import React from 'react';
import { CtaButton } from './CtaButton';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-ink px-5 pb-32 pt-12 text-center sm:pb-14" data-id="element-129" data-mp="3gezcj1s77n03">
      <div className="mx-auto max-w-3xl" data-id="element-130" data-mp="32o4d0g3lai96">
        <CtaButton label="Get instant access for USD $27" size="md" data-id="element-131" data-mp="32p5qer82vgu2" />
        <p className="mt-10 font-heading text-lg font-semibold text-white" data-id="element-132" data-mp="36oo87e4lrbso">Praxis & Motor Planning Clinical Pathway™</p>
        <p className="mt-1 text-sm text-white/60" data-id="element-133" data-mp="3ugbs3c3g5mlg">Created by Dr. Elowen Varelli</p>
        <p className="mt-6 text-xs leading-relaxed text-white/50" data-id="element-134" data-mp="38zbozae1d6l">
          Educational resource for Pediatric Occupational Therapists and Occupational Therapy students. This product does not
          provide diagnosis, replace standardized assessments, establish clinical classifications, or substitute for
          professional judgment, individualized clinical evaluation, supervised training, or appropriate multidisciplinary
          care.
        </p>
        <p className="mt-4 text-xs text-white/50" data-id="element-135" data-mp="2evxb71f3hj2d">© 2026 · Praxis & Motor Planning Clinical Pathway™ · All rights reserved.</p>
      </div>
    </footer>;
}